import React from 'react';
import InfoGrid from "../../../../../components/info-grid/info-grid.jsx";

const EncounterActionsContent = ({ data }) => {
    const actions = data?.data?.actions ?? [];

    if (!actions || !actions.length) return null;

    return (
        <>
            { actions && (
                <section className="space-y-4!">
                    <h2 className="w-full rounded-[5px] border border-[#e0e0e0] bg-[#efefef] py-0! text-center text-lg! text-[#4f4f4f] print:text-[19px]! print:break-after-avoid!">
                        AÇÕES DECORRENTES
                    </h2>

                    { actions.map((item, index) => {

                        const info = [
                            {
                                label: null,
                                value: item?.text,
                                dots: false,
                                span: 3
                            }
                        ];

                        return (
                            <>
                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'pb-3 px-0!'} contentClassName={'space-y-1'}/>
                                { index < actions.length-1 ? ( <div className="chart-divisor mt-[-12.5px]! mb-2! p-px!"/> ) : null}
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default EncounterActionsContent;